import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";

import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FilmGrain } from "@/components/FilmGrain";
import { Vignette } from "@/components/Vignette";
import { CinematicIntro } from "@/components/CinematicIntro";
import { FloatingActions } from "@/components/FloatingActions";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import MovieIntegrations from "@/pages/MovieIntegrations";
import Brands from "@/pages/Brands";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";

const SmoothScroll = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

function App() {
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    if (introDone) return;
    document.body.style.overflow = "hidden";
    window.__lenis?.stop?.();
    const safety = setTimeout(() => finishIntro(), 30000);
    return () => {
      document.body.style.overflow = "";
      clearTimeout(safety);
    };
  }, [introDone]);

  const finishIntro = () => {
    document.body.style.overflow = "";
    window.__lenis?.start?.();
    setIntroDone(true);
  };

  return (
    <div className="App">
      {!introDone && <CinematicIntro onDone={finishIntro} />}
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <FilmGrain />
          <Vignette />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/movie-integrations" element={<MovieIntegrations />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/privacy" element={<Legal type="privacy" />} />
              <Route path="/terms" element={<Legal type="terms" />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <FloatingActions />
          <Toaster position="top-center" richColors />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
